module.exports = __webpack_public_path__ + "static/peacethruplay-dd49ae61c36088015d8c591124f1e34c.png";